/* eslint-disable no-underscore-dangle */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
    Layout, Typography, Menu, Popover,
} from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { LogoutOutlined } from '@ant-design/icons';
import { mapRouteToElement } from '../Sidebar/config';
import './styles.css';
import { disconnectAsync } from '../../redux/actions/auth';
import { loadProfileImage } from '../../api/images';
import { getFullName } from '../../helpers/functions';
import CustomAvatar from '../Avatar';


const { Header } = Layout;
const { Title } = Typography;

const AppHeader = ({ currentRoute }) => {
    const [openPop, setOpenPop] = useState(false);
    const routeInfo = mapRouteToElement[currentRoute];
    const dispatch = useDispatch();
    const user = useSelector(state => state.auth.user);

    const PopoverContent = (
        <Menu>
            <Menu.Item onClick={() => dispatch(disconnectAsync())} icon={<LogoutOutlined />} key="0">
                Se déconnecter
            </Menu.Item>
        </Menu>
    );

    return (
        <Header className="header header-top justify-c-sb">
            {routeInfo ? (
                <div className="m-left-medium flex" style={{ height: 45 }}>
                    <div className="m-right-medium">
                        {routeInfo.icon({ fontSize: 40 })}

                    </div>
                    <Title level={3} style={{ lineHeight: 2 }}>
                        {routeInfo.title}
                    </Title>

                </div>


            ) : (<div />)}
            <Popover
                content={PopoverContent}
                trigger="hover"
                visible={openPop}
                onVisibleChange={setOpenPop}
            >
                <div
                    className="flex"
                    style={{ cursor: 'pointer', alignItems: 'center', alignSelf: 'flex-end' }}
                >
                    <span className="m-right-medium">{user.firstName && user.lastName ? getFullName(user) : null }</span>
                    <CustomAvatar
                        src={loadProfileImage(user._id, 'thumbnail')}
                        size={45}

                    />
                </div>
            </Popover>
        </Header>
    );
};

AppHeader.propTypes = {
    currentRoute: PropTypes.string.isRequired,
};

AppHeader.defaultProps = {
};

// const stateToProps = state => ({
// });


export default AppHeader;
